import React, { FC } from 'react';
import { ContextItem, ContextMenu } from '@law-connect/react-components';
import style from './style.module.less';
import { Typography } from '@galaxy-ds/core';

interface Props {
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
  title: string;
  items?: ContextItem[];
  props?: React.HTMLAttributes<HTMLDivElement> & { [key: string]: any };
}

export const Header: FC<Props> = ({ Icon, title, items, props }) => {
  return (
    <div className={style.header} {...props}>
      <div className={style.headerTextContainer}>
        <div className={style.folderIconContainer}>
          <Icon className={style.folderIcon} />
          {/* <DocumentIcon className={style.folderIcon} /> */}
        </div>
        <Typography variant='h2'>{title.toLocaleUpperCase()}</Typography>
      </div>
      {items ? (
        <ContextMenu
          items={items}
          className={style.contextMenu}
          menuItemsClassName={style.contextMenuItems}
        />
      ) : null}
    </div>
  );
};
